export const AZ = {
    translations: {
        notifications: 'Bildirişlər',
        markAllAsRead: 'Hamısını oxunmuş olaraq işarələ',
        poweredBy: 'tərəfindən təchiz edilmişdir',
        settings: 'Qəbulu',
        noNewNotification: 'Hələ burada görmək üçün yeni heç nə yoxdur',
    },
    lang: 'az',
};
//# sourceMappingURL=az.js.map